var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-gray-light py-2 md:py-3"},[_c('container',[_c('row',{staticClass:"flex-between"},[_c('column',{staticClass:"hidden xl:flex xl:w-7/12"},[_c('usps-list',{attrs:{"usps":_vm.usps,"default-usps":1}})],1),_vm._v(" "),_c('column',{staticClass:"w-full xl:w-5/12 flex-start"},[_c('header-carousel')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }